import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/admin/login");
        return;
      }
      const sessionId = decodeURIComponent(match[1]);
      try {
        await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin");
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/admin/login"), 1800);
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0F1C]" data-testid="auth-callback">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto rounded-full border-2 border-white/20 border-t-blue-500 animate-spin" />
        <p className="mt-4 text-slate-300 text-sm">
          {error ? "Sign-in failed. Redirecting…" : "Signing you in…"}
        </p>
      </div>
    </div>
  );
}
